import React from 'react';
import { Navigate } from 'react-router-dom';
import { useAuth } from '../../contexts/AuthContext';

const BaristaProtectedRoute = ({ children }) => {
  const { currentUser, loading } = useAuth();

  if (loading) {
    return (
      <div style={{
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        height: '100vh',
        background: '#f8f9fa',
        fontFamily: 'Inter, -apple-system, BlinkMacSystemFont, sans-serif'
      }}>
        <div style={{
          background: '#fff',
          padding: '32px',
          borderRadius: '12px',
          boxShadow: '0 4px 6px rgba(0, 0, 0, 0.1)',
          textAlign: 'center'
        }}>
          <div style={{
            width: '40px',
            height: '40px',
            border: '3px solid #e9ecef',
            borderTop: '3px solid #8b5a3c',
            borderRadius: '50%',
            animation: 'spin 1s linear infinite',
            margin: '0 auto 16px'
          }}></div>
          <div style={{ color: '#4a5568', fontSize: '16px' }}>Loading...</div>
        </div>
      </div>
    );
  }

  if (!currentUser) {
    return <Navigate to="/login" />;
  }

  // Check if user is admin, staff, or barista
  const isAdmin = currentUser.role === 'Admin' || currentUser.isAdmin;
  const isStaff = currentUser.role === 'Staff';
  const isBarista = currentUser.role === 'Barista';

  if (!isAdmin && !isStaff && !isBarista) {
    return (
      <div style={{
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        height: '100vh',
        background: '#f8f9fa',
        fontFamily: 'Inter, -apple-system, BlinkMacSystemFont, sans-serif',
        padding: '20px'
      }}>
        <div style={{
          background: '#fff',
          padding: '32px',
          borderRadius: '12px',
          boxShadow: '0 4px 6px rgba(0, 0, 0, 0.1)',
          textAlign: 'center',
          maxWidth: '400px',
          width: '100%'
        }}>
          <div style={{
            fontSize: '48px',
            marginBottom: '16px'
          }}>🚫</div>
          <h2 style={{
            color: '#2d3748',
            fontSize: '20px',
            fontWeight: '700',
            margin: '0 0 8px 0'
          }}>Access Denied</h2>
          <p style={{
            color: '#718096',
            fontSize: '14px',
            margin: '0 0 24px 0',
            lineHeight: '1.5'
          }}>
            You don't have permission to access the beans request system. 
            This area is restricted to baristas, staff, and administrators only.
          </p>
          <button 
            onClick={() => window.history.back()}
            style={{
              background: '#8b5a3c',
              color: '#fff',
              border: 'none',
              padding: '12px 24px',
              borderRadius: '8px',
              fontSize: '14px',
              fontWeight: '600',
              cursor: 'pointer',
              transition: 'all 0.2s ease'
            }}
            onMouseEnter={(e) => {
              e.target.style.background = '#7a4d35';
            }}
            onMouseLeave={(e) => {
              e.target.style.background = '#8b5a3c';
            }}
          >
            Go Back
          </button>
        </div>
      </div>
    );
  }

  return children;
};

export default BaristaProtectedRoute;